var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{attrs:{"type":"flex"}},[_c('iframe',{attrs:{"src":_vm.getUrl(),"width":"100%","height":"800","frameborder":"0","scrolling":"auto","id":"iframename","name":"iframename"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }